<style></style>

<template>
    <BTable id="connection-requests-table" 
            stacked="md"
            :items="tableData"
            :fields="fields"
            show-empty
            empty-text="You don't have any pending invitations to connect"
            empty-filtered-text="No pending invitations that match filters"
            data-name="Invited to Connect" 
            :sort-by.sync="sortBy" 
            :sort-desc.sync="sortDesc"
        >
            <template v-slot:cell(program_name)="{item}">
                {{item.program_name}}
            </template>
            <template v-slot:cell(created_at)="{item}">
                {{ formatDate(item.created_at) }}
            </template>
            <template v-slot:cell(last_resent_at)="{item}">
                {{ formatDate(item.last_resent_at) }}
            </template>
            <template v-slot:cell(resend-invite)="{item}">
                <button class="btn-orange-blue btn-xs" @click="resendConnectionRequest(item)"><small>Resend</small></button>
            </template>
            <template v-slot:cell(disconnect)="{item}">
                <a class="btn-orange-blue btn-sm" @click="deleteConnectionRequest(item)">Disconnect</a>
                <a class="btn-x" @click="deleteConnectionRequest(item)"><i class="fa fa-times" aria-hidden="true"></i></a>
            </template>
    </BTable>
</template>

<script>

    export default {
        props: {
            sortBy: {
                required: false,
                default: 'user-info',
                type: String
            },
            sortDesc: {
                required: false,
                default: false,
                type: Boolean
            },
            connectionRequests: {
                required: true,
                type: Array
            }
        },
        data() {
            return {
                fields: [
                    {
                        key: 'program_name',
                        label: 'User Information',
                        sortable: true,
                        thStyle: { width: '40%' }
                    },
                    {
                        key: 'created_at',
                        label: 'Date First Invited',
                        sortable: true
                    },
                    {
                        key: 'last_resent_at',
                        label: 'Date of Last Invite',
                        sortable: true
                    },
                    {
                        key: 'resend-invite',
                        label: 'Resend Invitation',
                    },
                    {
                        key: 'disconnect',
                        label: 'Disconnect',
                        sortable: false
                    }
                ],
            }
        },
        computed: {
            tableData() {
                return this.connectionRequests.map(item => {
                    item.program_name = item.program.name
                    return item
                })
            },
            formatDate(dateString, format = 'MM/DD/YY') {
                if (moment(dateString).isValid()) {
                    return moment(dateString).utc().format(format)
                }
                return null
            }
        },
        methods: {
            updateData() {
                // TODO: just remove the item from the list instead of reloading 
                window.location.reload();
            },
            deleteConnectionRequest(cr) {
                if (confirm('Are you sure you want to delete from this request to connect?')) {
                    axios.delete('api/connection-requests/' + cr.id)
                        .then(response => {
                            this.updateData()
                        })
                        .catch(error => {
                            if (error.response.status == 403) {
                                alert(error.response.data.message)
                            }
                        });
                }
            },
            resendConnectionRequest(cr) {
                axios.get('consultants/resend-connection-request/'+cr.id)
                    .then(response => {
                        this.updateData();
                    });
            },

        }
    
}
</script>